/* eslint-disable */
import type {DocumentNode} from 'graphql';
import * as ApolloReactHooks from '@apollo/client/react';
import type {DeleteCharacterSheetMutation, DeleteCharacterSheetMutationVariables} from '../types';

export const DeleteCharacterSheetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteCharacterSheet"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteCharacterSheet"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode;
/** hook для мутации "DeleteCharacterSheet" */
export function useDeleteCharacterSheetMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        DeleteCharacterSheetMutation,
        DeleteCharacterSheetMutationVariables        
    >,
) {
    return ApolloReactHooks.useMutation<
    DeleteCharacterSheetMutation,
    DeleteCharacterSheetMutationVariables
    >(DeleteCharacterSheetDocument, baseOptions ?? ({} as ApolloReactHooks.MutationHookOptions<DeleteCharacterSheetMutation, DeleteCharacterSheetMutationVariables>));
}
